import { truncateHtml } from 'shared-widget-components/src/utils/truncateHtml';

interface EventDescriptionProps {
  description: string;
  textColor: string;
}

/**
 * EventDescription component
 * this component is responsible for rendering the event description
 * @param description - the description of the event
 * @param textColor - the color of the text
 * @returns EventDescription component
 */

export const EventDescription = ({ description, textColor }: EventDescriptionProps) => {
  const truncatedDescription = truncateHtml(description, 120);

  return (
    <p className='min-[350px]:text-[14px] font-medium min-[350px]:mb-1 sm:mb-2 min-[1200px]:mb-3 sm:text-[16px] mr-2 w-full font-body' style={{ color: textColor }}>
      {truncatedDescription}
    </p>
  );
};
